import styled from 'styled-components';

import IconButton from '@polyai/ui/components/atoms/IconButton';
import themeSpacing from '@polyai/ui/styles/config/spacing';

import { FormTextInput } from 'components/molecules/Form/FormTextInput';
import type { ModalSchema } from 'screens/Handoff/components/FormHandoffModal';

export const TextAreaInput = styled(FormTextInput<ModalSchema>)`
  min-height: 90px;
`;
export const DeleteIcon = styled(IconButton)<{
  $hasErrors?: boolean;
  $isFirst?: boolean;
}>`
  margin-top: ${({ $isFirst }) => $isFirst && themeSpacing.sm3};
  margin-bottom: ${({ $hasErrors }) =>
    $hasErrors ? '18px' : themeSpacing.xs2};
`;
export const InputWrapper = styled.div`
  width: 100%;
`;
